// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"7e5fd063","455":"e5484f01","977":"97ee8dbe"}[chunkId] + ".chunk.js";
};